import * as React from 'react';
import GetProductTagsQuery from '../../components/Query/ProductTags/ProductTags';
import { findPrice } from '../../helpers/prices';
import { getProductVariantPrices } from 'helpers/src/prices/getProductVariantPrices';

interface IProductTagsProps {
  language?: string;
  variant: GQL.IProductVariant;
  hideTags?: string[];
}

class ProductTags extends React.Component<IProductTagsProps> {

  render() {
    const { language, variant, hideTags } = this.props;

    const tagsInProduct = variant.product.tags;

    if (!tagsInProduct) {
      return null;
    }

    return (
      <div className="productTags">
        <GetProductTagsQuery>
          {({ productTags }: any) => {
            if (productTags && productTags.productTags) {
              return productTags.productTags
                .filter((tag: GQL.IProductTag) => {
                  if (hideTags) {
                    return hideTags.some((hideTag: string) => hideTag == tag.id || hideTag == tag.name) === false;
                  }
                  return true;
                })
                .map((tag: GQL.IProductTag) => {

                  // má produkt tento tag ?
                  if (tagsInProduct && tagsInProduct.find((tagId: string) => tagId === tag.id)) {
                    let title = tag.title[language || 'en']; // todo: fuj

                    // tag se zobrazením slevy
                    const isDiscount = title ? title.search('{discount}') >= 0 : false;
                    if (isDiscount) {
                      // doporučená cena
                      const recommendedPrice = findPrice(getProductVariantPrices(variant as any), true, null, variant);
                      // ceny
                      const price = findPrice(getProductVariantPrices(variant as any), false, null, variant);

                      if (!recommendedPrice || !price) {
                        return null;
                      }

                      const discount = recommendedPrice - price;

                      // produkt není zlevněný
                      if (discount <= 0) {
                        return null;
                      }

                      title = title.replace('{discount}', `${0 - Math.round((discount / recommendedPrice) * 100)}%`);
                    }

                    return (
                      <div key={tag.id}>
                        <span className={`productTag[${tag.slug}]`} style={{ backgroundColor: tag.color || '' }}>
                          {title}
                        </span>
                      </div>
                    );
                  }

                  return null;
                });
            }

            return null;
          }}
        </GetProductTagsQuery>
      </div>
    );
  }
}

export default ProductTags;


// WEBPACK FOOTER //
// ./src/modules/ProductTags/ProductTags.tsx